module.exports = __webpack_public_path__ + "img/Ruler-measure-filled.f79dab57.svg";